import React, { useState, useEffect } from 'react';

import { dataGridPremiumColumns, getIcon } from '../../utils/helper';
import { DataGridIdentifiers, DatagridPremiumUi } from '../Interface';
import taskDowntimeReasonService from '../../service/taskDowntimeReason.service';

export const TaskDowntimeReasonReports = ({ refetch, values, viewField, operatorsDisabled, rowSelection }) => {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;
  const { rowSelectionModel, setRowSelectionModel } = rowSelection;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'code', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    taskDowntimeReasonService.getItems(gridState).then((data) => {
      setReports(data);
    });
  };

  const columns = dataGridPremiumColumns([
    {
      field: 'code',
      headerName: 'Leállás kódja',
      type: 'string',
    },
    {
      field: 'name',
      headerName: 'Leállás megnevezése',
      type: 'string',
    },
    {
      field: 'icon',
      headerName: 'Ikon',
      type: 'string',
      sortable: false,
      filterable: false,
      renderCell: (data) => {
        return getIcon(data.row.icon, '1.7rem');
      },
    },
    {
      field: 'active',
      headerName: 'Aktív',
      type: 'boolean',
    },
  ]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.TaskDowntimeReasonTable}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      getRowId={(row) => row.code}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
};
